export class FormValidationService {

    public revalidate(isolatedScope, elementName):void {

        if(isolatedScope && isolatedScope.$broadcast){
            isolatedScope.$broadcast('angularValidation.revalidate', elementName);
        }
    }
}
